import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  pages = ['home', 'methods', 'projects', 'profile' ];
  activePage = this.pages[0];

  constructor() { }

  ngOnInit(): void {
  }

}
